import { Tournament } from 'functions/src/types/firestore/Game/Tournament';
import { getTournament } from './form-fields.ts/getTournament';

export type EditableTournament = Omit<
  Tournament<Date>,
  | 'phase'
  | 'competitorCount'
  | 'waitlistAggregated'
  | 'guestlistAggregated'
  | 'participantsAggregated'
  | 'adminIds'
  | 'subscribedUserIds'
  | 'subscribableFields'
  | 'type'
  | 'id'
>;

export function toFormInput(tournament: EditableTournament) {
  const input = getTournament(tournament);
  return input;
}
